import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PageMeta from "./components/PageMeta";

const workflow = [
  "Ohjelma kerää uutisaiheita määritetyistä julkisista uutislähteistä.",
  "Jokaisesta valitusta uutisesta luodaan yksi tyylitelty kuva.",
  "Video tarkistetaan automaattisella laadunvarmistuksella ennen julkaisemista.",
  "Hyväksytty video ladataan käyttäjän valtuuttamalle YouTube-kanavalle YouTube Data API v3:n avulla.",
  "Sama paikallisesti tuotettu video voidaan lähettää Telegram-kanavalle Telegram Bot API:n avulla.",
  "YouTube-valtuutusta käytetään ainoastaan sovelluksen tuottamien videoiden lataamiseen ja niihin liittyvien julkaisutietojen käsittelyyn.",
];

export default function YtVidCreatorPage() {
  return (
    <main className="product-info-page" lang="fi">
      <PageMeta
        title="YTVidCreator | PK-Forensics"
        description="YTVidCreator on PK-Forensicsin automaattinen sisällöntuotantotyökalu, joka luo uutisaiheista videoita YouTubeen ja Telegramiin."
      />

      <header className="product-info-hero">
        <div className="page-shell product-info-hero-grid">
          <div>
            <p className="eyebrow"><span />PK-Forensics / Sisällöntuotanto</p>
            <h1>YTVidCreator</h1>
          </div>
          <p className="product-info-lead">
            YTVidCreator on yrityksen oma automaattinen sisällöntuotantotyökalu, joka muodostaa
            ajankohtaisista politiikkauutisista lyhyitä, visuaalisia videoita. Työkalu tuottaa
            videot paikallisesti ja julkaisee hyväksytyn videon käyttäjän valtuuttamalle
            YouTube-kanavalle sekä määritetylle Telegram-kanavalle.
          </p>
        </div>
      </header>

      <section className="product-info-section" aria-labelledby="workflow-title">
        <div className="page-shell product-info-layout">
          <div className="product-info-heading">
            <p className="section-label">Työnkulku</p>
            <h2 id="workflow-title">Miten palvelu toimii?</h2>
          </div>
          <ol className="product-info-steps">
            {workflow.map((item, index) => (
              <li key={item}>
                <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
                <p>{item}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="product-info-section product-info-section-dark" aria-labelledby="google-data-title">
        <div className="page-shell product-info-layout">
          <div className="product-info-heading">
            <p className="section-label section-label-light">OAuth 2.0</p>
            <h2 id="google-data-title">Google-tilin tietojen käyttö</h2>
          </div>
          <div className="product-info-copy">
            <p>
              YTVidCreator pyytää YouTuben videoiden lataamiseen tarvittavan OAuth-käyttöoikeuden.
              Sovellus ei käytä Google-tilin tietoja mainontaan, profilointiin tai jälleenmyyntiin.
              Tarkempi kuvaus tietojen käytöstä, säilyttämisestä ja poistamisesta löytyy
              YTVidCreatorin tietosuojaselosteesta.
            </p>
            <Link className="button button-accent" to="/ytvidcreator/tietosuoja">
              Tutustu YTVidCreatorin tietosuojaselosteeseen <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      <section className="product-contact-section" aria-labelledby="product-contact-title">
        <div className="page-shell product-contact-card">
          <div>
            <p className="section-label">Yhteys</p>
            <h2 id="product-contact-title">Kysyttävää YTVidCreatorista?</h2>
          </div>
          <p>
            Yhteydenotot:{" "}
            <a href="mailto:jarmo@pk-forensics.fi">jarmo@pk-forensics.fi</a>
          </p>
        </div>
      </section>
    </main>
  );
}
